@if (isDebugMode) {
    <span class="material-symbols-outlined debug-button"  (click)="debugPopover.toggle($event)">
        bug_report
    </span>
    <p-popover #debugPopover [dismissable]="false">
        <div class="close-debug-popover" (click)="debugPopover.hide()">
            <span class="material-symbols-outlined">
                close
            </span>
        </div>
        <div>ID: {{extra.rateId}}</div>
        <div>PMS name: {{extra.extraName}}</div>
        <div>calculationRule: {{extra.calculationRule}}</div>
        <div>postingRhythm: {{extra.postingRhythm}}</div>
        <div>Price: {{extra.totalPriceForStayWithTaxes}}</div>
        <div>Pimdata: <pre>{{extra.pim|json}}</pre></div>
        <!-- {{rate|json}} -->
    </p-popover>
}
